import { fetchApi } from '~/queries'

export default ({ app }) => {
  const GA_URL_CONST = 'google-analytics.com';
  if (import.meta.client) {
    const originalFetch = window.fetch;
    window.fetch = async function (input, init) {
      if (typeof input === 'string' && input.includes(GA_URL_CONST)) {
        try {
          return await originalFetch(input, init);
        } catch (error) {
          sendFailedRequestData(input, init, error);
        }
      } else {
        return originalFetch(input, init);
      }

    };
    function sendFailedRequestData(input, init, errorOrResponse) {
      // Should be undefined or 0 for blocked requests
      if (!errorOrResponse.status) {
        console.log('Request was blocked')
        fetchApi('/ga/event', {
          method: 'POST',
          body: {
            url: input,
            method: init.method,
            data: init.body,
          }
        })
      }
    }
  }
};
